// extracted by mini-css-extract-plugin
export var hideEditor = "_mh-2";
export var infoIcon = "_mh-3";
export var label = "_mh-1";
export var labelContainer = "_mh-0";
export var readonlyText = "_mh-4";